import React from 'react';
import { KontentStringValue } from '../../../types/KontentProps';
import parse from 'html-react-parser';

interface Headline {
    text: KontentStringValue;
    elementCodename?: string;
}

const PlainTextElement: React.FC<Headline> = ({ text, elementCodename }) => {
    if (!text || !(typeof text?.value === 'string')) return null;
    const words = text?.value?.split(' ');

    const parsedText = words
        ?.map((word, idx) => {
            if (word.includes('®')) {
                const wordParts = word.split('®');

                return `${wordParts[0]}<sup>&reg;</sup>`;
            }

            if (word.includes('--')) {
                const wordParts = word.split('--');

                return wordParts
                    .map((p, idx) => {
                        if (idx != wordParts.length - 1) {
                            return `${p}&shy;`;
                        }

                        return p;
                    })
                    .join('');
            }

            return word;
        })
        ?.join(' ');

    if (!parsedText) {
        return elementCodename ? (
            <span data-kontent-element-codename={elementCodename}>
                {text.value}
            </span>
        ) : (
            <>{text.value}</>
        );
    }

    return elementCodename ? (
        <span data-kontent-element-codename={elementCodename}>
            {parse(parsedText)}
        </span>
    ) : (
        <>{parse(parsedText)}</>
    );
};

export default PlainTextElement;
